<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>请假</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.qjtype" placeholder="请选择" style="width: 100%">
              <el-option label="请选择请假类型" value="0"></el-option>
              <el-option label="年假" value="1"></el-option>
              <el-option label="事假" value="2"></el-option>
              <el-option label="病假" value="3"></el-option>
              <el-option label="调休假" value="4"></el-option>
              <el-option label="婚假" value="5"></el-option>
              <el-option label="产假" value="6"></el-option>
              <el-option label="陪产假" value="7"></el-option>
              <el-option label="其他" value="8"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="10%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="10%"></el-table-column>
          <el-table-column prop="Name1" label="申请人" min-width="4%"></el-table-column>
          <el-table-column prop="Qjtype" label="请假类型" min-width="5%"></el-table-column>
          <el-table-column prop="Qjliyou" label="申请事由" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="请假日期" min-width="7%"></el-table-column>
          <el-table-column prop="Qjtime" label="请假时长" min-width="6%"></el-table-column>
          <el-table-column prop="Qjbegin" label="开始日期" min-width="7%"></el-table-column>
          <el-table-column prop="Qjend" label="结束日期" min-width="7%"></el-table-column>
          <el-table-column prop="Qjbeizhu" label="备注" min-width="12%"></el-table-column>
          <el-table-column prop="Qjstatusname" label="审批状态" min-width="5%"></el-table-column>
          <el-table-column prop="Name2" label="部门主管" min-width="4%"></el-table-column>
          <el-table-column prop="Name3" label="副总经理" min-width="4%"></el-table-column>
          <el-table-column prop="Name4" label="总经理" min-width="4%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Qjstatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Qjstatus == 1 && SubRule_ShenPiQingJia_BuMen" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">部门主管审核</el-button>
              <el-button v-if="scope.row.Qjstatus == 2 && SubRule_ShenPiQingJia_DanWei" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">副总经理审核</el-button>
              <el-button v-if="scope.row.Qjstatus == 3 && SubRule_ShenPiQingJia_DanWeiZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe3(scope.row)">总经理审核</el-button>
              <el-button v-if="SubRule_ShenPiQingJia_RenShi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">人事备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="申请请假" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">请假类型(必选)</span>
          </label>
          <el-select v-model="addForm.qjtype" placeholder="请选择" style="width: 100%">
            <el-option label="请选择" value="0"></el-option>
            <el-option label="年假" value="1"></el-option>
            <el-option label="事假" value="2"></el-option>
            <el-option label="病假" value="3"></el-option>
            <el-option label="调休假" value="4"></el-option>
            <el-option label="婚假" value="5"></el-option>
            <el-option label="产假" value="6"></el-option>
            <el-option label="陪产假" value="7"></el-option>
            <el-option label="其他" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">请假事由(必填)</span>
          </label>
          <el-input type="textarea" :rows="3" v-model="addForm.qjliyou"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">请假时长(必填)</span>
          </label>
          <el-input v-model="addForm.qjtime"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">开始日期(必填)</span>
          </label>
          <el-date-picker v-model="addForm.qjbegin" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">结束日期(必填)</span>
          </label>
          <el-date-picker v-model="addForm.qjend" type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input type="textarea" :rows="3" v-model="addForm.qjbeizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 添加备注 start -->
    <el-tab-pane label="添加备注" name="three" v-if="displayEdit">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">备注(必填)</span>
          </label>
          <el-input type="textarea" :rows="5" v-model="editForm.qjbeizhu"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyShenPiQingJia',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        qjtype: '0',
        qjliyou: '',
        qjtime: '',
        qjbegin: '',
        qjend: '',
        qjbeizhu: ''
      },
      editForm: {
        qjid: '',
        qjbeizhu: ''
      },
      displayEdit: false,
      timer: '',
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        qjtype: '0'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiQingJiaSHUrl: '',
      qjid: 0,
      SubRule_ShenPiQingJia_BuMen: false,
      SubRule_ShenPiQingJia_DanWei: false,
      SubRule_ShenPiQingJia_DanWeiZong: false,
      SubRule_ShenPiQingJia_RenShi: false
    }
  },
  mounted () {
    this.apiGetShenPiQingJiaNum()
    this.apiGetShenPiQingJiaList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiQingJia_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiQingJia_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiQingJia_DanWei', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiQingJia_DanWei = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiQingJia_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiQingJia_DanWeiZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiQingJia_RenShi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiQingJia_RenShi = true
      }
    })
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      this.apiAddShenPiQingJia()
    },
    clickmodify (row) {
      this.activeName = 'three'
      this.displayEdit = true

      this.editForm.qjbeizhu = row.Qjbeizhu
      this.editForm.qjid = row.Id
    },
    clicksave () {
      this.apiEditShenPiQingJia()
    },
    clickreturn () {
      this.activeName = 'first'
      this.displayEdit = false
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiQingJiaSHUrl = Vue.prototype.global.Url_ShenPiQingJiaSH1
      this.qjid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiQingJiaSHUrl = Vue.prototype.global.Url_ShenPiQingJiaSH2
      this.qjid = row.Id
    },
    ShenHe3 (row) {
      this.dialogVisible = true
      this.apiShenPiQingJiaSHUrl = Vue.prototype.global.Url_ShenPiQingJiaSH3
      this.qjid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiQingJiaSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiQingJiaSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiQingJia(row.Id)
      })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiQingJiaNum()
      this.apiGetShenPiQingJiaList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiQingJiaList()
    },
    apiGetShenPiQingJiaNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        qjtype: that.keywords.qjtype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiQingJiaNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiQingJiaList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        qjtype: that.keywords.qjtype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiQingJiaList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiQingJia: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qjtype: that.addForm.qjtype,
        qjliyou: that.addForm.qjliyou,
        qjtime: that.addForm.qjtime,
        qjbegin: that.addForm.qjbegin,
        qjend: that.addForm.qjend,
        qjbeizhu: that.addForm.qjbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiQingJia, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiQingJiaNum()
            that.apiGetShenPiQingJiaList()

            // 清空添加
            that.addForm.qjtype = '0'
            that.addForm.qjliyou = ''
            that.addForm.qjtime = ''
            that.addForm.qjbegin = ''
            that.addForm.qjend = ''
            that.addForm.qjbeizhu = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiQingJia: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qjid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiQingJia, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiQingJiaNum()
            that.apiGetShenPiQingJiaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditShenPiQingJia: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qjid: that.editForm.qjid,
        qjbeizhu: that.editForm.qjbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiQingJia, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiQingJiaNum()
            that.apiGetShenPiQingJiaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiQingJiaSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        qjid: that.qjid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiQingJiaSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiQingJiaNum()
            that.apiGetShenPiQingJiaList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
